module.exports = __webpack_public_path__ + "static/media/31JFA5.33d70074.jpg";